<template>
    <div class="animated fadeIn">
        <b-card>
            <template v-slot:header>
                <h5>Input Role</h5>
            </template>
            <b-form @submit.prevent="openModalConfirm">
                <div class="form-content-wrapper">
                    <b-row>
                        <b-col md="4">
                            <b-form-group label="Nama Posisi">
                                <b-form-input v-model="input.namaPosisi" name="namaPosisi" required></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="4">
                            <b-form-group label="Level">
                                <b-form-input v-model="input.level" name="level" required></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper">
                    <b-button type="submit" name="roleSubmitBtn" variant="pgiBtn">Kirim</b-button>
                </div>
            </b-form>
        </b-card>
        <ModalConfirm id="modal-confirm-input" title="Confirm Input Role" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menginput role ini?" @submit="onSubmit" />
    </div>
</template>

<script>
export default {
    name: 'input-role',
    data(){
        return{
            isSubmitting: false,
            input: {
                namaPosisi: "",
                level: null,
            }
        }
    },
    
    methods: {
        
        //----------------- Fungsi Submit Data -----------------

        onSubmit(){
            let payload = new FormData()

            //----------------- Append Data Role -----------------

            payload.append("name", this.input.namaPosisi)
            payload.append("level", this.input.level)


            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true

            this.$axios.post("role/", payload).then(() => {
                this.$helper.setFlash(`Role baru telah berhasil dibuat!`)
                let path = this.$route.path.split("/")
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },


        //----------------- Fungsi Lain -----------------

        openModalConfirm(){
            this.$bvModal.show("modal-confirm-input")
        }

    },

    watch: {
        "input.level": function(newValue) {
            if(newValue.substring(0, 1) == '0'){
                const newValueCheck = newValue.substring(1)
                const result = newValueCheck.replace(/[^0-9]/g, "");
                this.$nextTick(() => this.input.level = result);
            }else{
                const result = newValue.replace(/[^0-9]/g, "");
                this.$nextTick(() => this.input.level = result);
            }
        }
    }
}
</script>
